import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";

function Btn(props) {
  const {
    isLoading,
    text,
    variant,
    btnVariant,
    type,
    className,
    disabled,
    withIconLeft,
    withIconRight,
    withOnlyIcon,
    btnLabel,
    ...rest
  } = props;

  return (
    <Button type={type} className={`${btnVariant} ${className}`} variant={variant} disabled={disabled} {...rest}>
      {withIconLeft && (
        <>
          <span className={withIconLeft}></span>
          <span>{btnLabel}</span>
        </>

        // How to use :
        // import Btn from "lib/button/Btn";
        // <Btn
        //   variant="primary"
        //   btnLabel="Hello"
        //   btnVariant="btn-icon-text"
        //   withIconLeft="inic inic-person"
        // />
      )}

      {withIconRight && (
        <>
          <span>{btnLabel}</span>
          <span className={withIconRight}></span>
        </>

        // How to use :
        // import Btn from "lib/button/Btn";
        // <Btn
        //   variant="primary"
        //   btnLabel="Hello"
        //   btnVariant="btn-text-icon"
        //   withIconRight="inic inic-person"
        // />
      )}

      {
        withOnlyIcon && <span className={withOnlyIcon}></span>

        // How to use :
        // import Btn from "lib/button/Btn";
        // <Btn
        //   variant="primary"
        //   btnVariant="btn-only-icon"
        //   withOnlyIcon="inic inic-person"
        // />
      }

      {isLoading ? (
        <>
          <span>{text}</span>
          <span className="spinner-border spinner-border-sm d-inline-block ms-6"></span>
        </>
      ) : (
        text && <span>{text}</span>

        // How to use :
        // import Btn from "lib/button/Btn";
        // <Btn
        //   variant="primary"
        //   text="Hello"
        // />
      )}
    </Button>
  );
}

export const defaultProps = {
  variant: "",
  type: "button",
  className: "",
  disabled: false,
  placeholder: "",
  label: "",
  text: "",
  isLoading: false,
};

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
};

Btn.defaultProps = defaultProps;

Btn.propTypes = propTypes;
export default Btn;
